import { useMutation, useQuery } from '@tanstack/react-query';
import { findUsers, impersonateUser } from './fetchImpersonateUser';
import { useKeycloak } from '../../../useKeycloakAndInit';
import useDebounce from '../../shared/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { GlobalReactQueryOptions } from '../../config';

export const useFindUsersForImpersonation = ({ enabled, searchString }: { enabled: boolean; searchString: string }) => {
    const kc = useKeycloak();
    const [debouncedSearchString] = useDebounce(searchString, 400);

    const { data, isLoading } = useQuery(
        ['impersonationUsers', debouncedSearchString],
        () => findUsers({ searchString: debouncedSearchString, kc: kc }),
        { ...GlobalReactQueryOptions, enabled }
    );

    return { data: data ?? [], isLoading };
};

export const useImpersonateUser = () => {
    const kc = useKeycloak();
    const navigate = useNavigate();

    return useMutation((userId: string) => impersonateUser({ userId, kc }), {
        onSuccess: () => {
            navigate(0); // this is basically a page reload
        }
    });
};
